import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const BatteryChargingIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M3.33333 5C1.49167 5 0 6.45437 0 8.25V14.75C0 16.5456 1.49167 18 3.33333 18H7.175C6.69167 17.4719 6.5375 16.7203 6.77917 16.05H3.33333C2.59583 16.05 2 15.4691 2 14.75V8.25C2 7.53094 2.59583 6.95 3.33333 6.95H9.96667L12.4667 5H3.33333ZM19.3333 16.05H12.7L10.2 18H19.3333C21.175 18 22.6667 16.5456 22.6667 14.75V14.1C23.4042 14.1 24 13.5191 24 12.8V10.2C24 9.48094 23.4042 8.9 22.6667 8.9V8.25C22.6667 6.45437 21.175 5 19.3333 5H15.4917C15.975 5.52812 16.1292 6.27969 15.8875 6.95H19.3333C20.0708 6.95 20.6667 7.53094 20.6667 8.25V14.75C20.6667 15.4691 20.0708 16.05 19.3333 16.05ZM14.4208 5.79625C14.1792 5.60531 13.8292 5.60531 13.5833 5.79219L6.91667 10.9922C6.69583 11.1628 6.60833 11.4553 6.70417 11.7153C6.8 11.9753 7.05 12.15 7.33333 12.15H10.2542L8.07083 16.4075C7.92917 16.6797 8.00417 17.0128 8.25 17.2037C8.49583 17.3947 8.84167 17.3947 9.0875 17.2078L15.7542 12.0078C15.975 11.8372 16.0625 11.5447 15.9667 11.2847C15.8708 11.0247 15.6208 10.85 15.3375 10.85H12.4125L14.5958 6.5925C14.7375 6.32031 14.6625 5.98719 14.4208 5.79625Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default BatteryChargingIcon
